import api from "./api";

export default {
  getAll: () => api.get("/clientes"),
  getById: (id) => api.get(`/clientes/${id}`),
  create: (data) => api.post("/clientes", { cliente: data }),
  update: (id, data) => api.put(`/clientes/${id}`, { cliente: data }),
  destroy: (id) => api.delete(`/clientes/${id}`),
};
